export enum OddsVariant {
  Keno = 'keno',
  GluecksSpirale = 'gluecksspirale',
  Eurojackpot = 'eurojackpot',
  Lotto6aus49 = 'lotto6aus49',
  Super6Spiel77 = 'super6spiel77',
  Plus5 = 'plus5',
  TotoAW = 'totoaw',
  TotoEW = 'totoew',
}

export const ODDS_VARIANTS = {
  '1': OddsVariant.Eurojackpot,
  '2': OddsVariant.GluecksSpirale,
  '3': OddsVariant.Keno,
  '4': OddsVariant.Lotto6aus49,
  '8': OddsVariant.TotoAW,
  '9': OddsVariant.TotoEW,
};
